import { render } from "./ViewWarehouse.vue?vue&type=template&id=67451c6e"
import script from "./ViewWarehouse.vue?vue&type=script&lang=js"
export * from "./ViewWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__